import React, { useState, useEffect } from "react";
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";
import van from "../../../assets/images/van.png";
import signature from "../../../assets/images/signature.png";

const styles = StyleSheet.create({
  page: {
    // flexDirection: "row",
    backgroundColor: "#fff",
    border: "1px solid #000",
    width: "100%",
    margin: "auto",
    paddingHorizontal: 35,
  },
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingTop: 20,
    flexDirection: "row",
  },
  heading: {
    fontStyle: "normal",
    fontWeight: 900,
    fontSize: 13,
    textTransform: "uppercase",
    color: "#0B0B0B",
    marginBottom: 4,
  },
  NotesHead: {
    fontStyle: "normal",
    fontWeight: 900,
    fontSize: 13,
    textTransform: "uppercase",
    color: "#0B0B0B",
    marginBottom: 4,
  },
  label: {
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: 14,
    marginBottom: 4,
    color: "rgba(11, 11, 11, 0.6)",
  },
  address: {
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: 12,
    color: "#0B0B0B",
  },
  note: {
    fontStyle: "italic",
    fontWeight: 500,
    fontSize: 12,
    color: "#0B0B0B",
  },
  boxsec: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  Vanmain: {
    textAlign: "center",
    marginBottom: "20px",
    marginTop: "0px",
  },
  Vanimage: {
    width: 80,
    height: 80,
    marginTop: 0,
  },
  Paramain: {
    marginBottom: "10px",
    paddingBottom: "10px",
  },
  notesmain: {
    width: "100%",
    marginBottom: 20,
  },
  customersec: {
    fontStyle: "normal",
    fontWeight: 900,
    fontSize: 13,
    textTransform: "uppercase",
    color: "#0B0B0B",
    marginBottom: 4,
  },
  signatureimg: {
    width: "100px",
  },
});

const OrderInPDF = ({ OrderData = [] }) => {
  const [PickUpSignature, SetPickUpSignature] = useState(null);
  const [DropOffSignature, SetDropOffSignature] = useState(null);

  // useEffect(() => {
  //   if (OrderData.stops && OrderData.stops.length > 0) {
  //     SetPickUpSignature(OrderData?.stops[0]?.stop_confirmation?.signature_url);
  //     SetDropOffSignature(
  //       OrderData?.stops[1]?.stop_confirmation?.signature_url
  //     );
  //   }
  // }, [OrderData]);
  // console.log("DropOffSignature", DropOffSignature);

  return (
    <>
      {OrderData?.stops && OrderData?.stops?.length > 0 && (
        <>
          <Document>
            <Page size="A4" style={styles.page}>
              <View style={styles.container}>
                <View>
                  {OrderData.stops && OrderData.stops.length > 0 && (
                    <>
                      <View>
                        <View style={styles.Vanmain}>
                          <Image src={van} alt="van" style={styles.Vanimage} />
                        </View>
                      </View>

                      <View style={styles.Paramain}>
                        <View>
                          <Text style={styles.heading}>From</Text>
                        </View>
                        <View>
                          <Text style={styles.label}>
                            {OrderData?.stops[0]?.contact_name || "N/A"}
                          </Text>
                        </View>
                        <View>
                          <Text style={styles.address}>
                            {OrderData?.stops[0]?.location?.address || "N/A"}
                          </Text>
                        </View>
                      </View>

                      <View style={styles.Paramain}>
                        <Text style={styles.heading}>To</Text>
                        <Text style={styles.label}>
                          {OrderData?.stops[1]?.contact_name || "N/A"}
                        </Text>
                        <Text style={styles.address}>
                          {OrderData?.stops[1]?.location?.address || "N/A"}
                        </Text>
                      </View>

                      <View style={styles.notesmain}>
                        <Text style={styles.NotesHead}>Notes</Text>
                        <Text style={styles.note}>
                          {OrderData?.stops[0]?.notes || "N/A"}
                        </Text>
                      </View>

                      <View>
                        <Text>
                          <Text style={styles.customersec}>
                            Pickup customer : &nbsp;
                          </Text>
                          <View style={styles.boxsec}>
                            <Text style={styles.label}>
                              {OrderData?.stops[0]?.contact_name || "N/A"}{" "}
                              &nbsp; &nbsp;
                            </Text>
                            <Image
                              src={PickUpSignature || signature}
                              alt="signature"
                              style={styles.signatureimg}
                            />
                          </View>
                        </Text>
                      </View>

                      <View>
                        <View>
                          <Text>
                            <Text style={styles.heading}>
                              Drop-off customer : &nbsp;
                            </Text>
                            <View style={styles.boxsec}>
                              <Text style={styles.label}>
                                {OrderData?.stops[1]?.contact_name || "N/A"}{" "}
                                &nbsp; &nbsp;
                              </Text>
                              {/* <Image
                                src={
                                  OrderData?.stops[1]?.stop_confirmation
                                    ?.signature_url || signature
                                }
                                alt="signature"
                                style={styles.signatureimg}
                              />{" "} */}
                              <Image
                                src={DropOffSignature || signature}
                                alt="signature"
                                style={styles.signatureimg}
                              />
                            </View>
                          </Text>
                        </View>
                      </View>
                    </>
                  )}
                </View>
              </View>
            </Page>
          </Document>
        </>
      )}
    </>
  );
};

export default OrderInPDF;
